import React, { useEffect, useState } from 'react'
import {
    getCityByStateServices,
    getzipCodeServices,
    getCountriesServices,
    getStateByCountryServices,
    getSatLocalityServices,
    getCologneServices
} from 'services/selectServices/services'
import { parseToSelectOption } from 'util/funcionesNews'

const useLocation = (): any => {
    const [countries, setCountries] = useState<any[]>([])
    const [zipCode, setZipCode] = useState<any[]>([])
    const [states, setStates] = useState<any[]>([])
    const [cities, setCities] = useState<any[]>([])
    const [locality, setLocality] = useState<any[]>([])
    const [cologne, setCologne] = useState<any[]>([])
    const [formLocation, setFormLocation] = useState<{
        country: number | null
        zipCode: number | null
        state: number | null
        cities: number | null
        locality: number | null
        cologne: number | null
    }>({
        country: null,
        zipCode: null,
        state: null,
        cities: null,
        locality: null,
        cologne: null
    })
    const [loaders, setLoaders] = useState({
        loaderCountry: false,
        loaderZipCode: false,
        loaderState: false,
        loaderCity: false,
        loaderLocality: false,
        loaderCologne: false
    })

    const handlerLoaders = (
        name: 'loaderCountry' | 'loaderZipCode' | 'loaderState' | 'loaderCity' | 'loaderLocality' | 'loaderCologne',
        value: boolean
    ) => {
        setLoaders(prev => ({ ...prev, [name]: value }))
    }

    const handlerForm = (
        name: 'country' | 'zipCode' | 'state' | 'cities' | 'locality' | 'cologne',
        value: number | null
    ) => {
        setFormLocation(prev => ({ ...prev, [name]: value }))
    }

    const handlerReset = () => {
        setFormLocation({
            country: null,
            zipCode: null,
            state: null,
            cities: null,
            locality: null,
            cologne: null
        })
    }

    // Consultamos los paises
    useEffect(() => {
        const getCountries = async () => {
            handlerLoaders('loaderCountry', true)
            const data = await getCountriesServices()
            setCountries(parseToSelectOption(data, 'nombre_pais', 'id_paises'))
            handlerLoaders('loaderCountry', false)
        }
        getCountries()
    }, [])

    // Consultamos los codipos postales
    useEffect(() => {
        setZipCode([])
        setCities([])
        setStates([])
        setLocality([])
        setCologne([])

        const isMexico = formLocation.country === 493
        const getzipCode = async () => {
            try {
                handlerLoaders('loaderZipCode', true)
                const data = await getzipCodeServices()
                setZipCode(parseToSelectOption(data, 'label', 'value'))
                handlerLoaders('loaderZipCode', false)
            } catch (error) {
                setZipCode([])
            }
        }

        if (isMexico) {
            getzipCode()
        }

        const getStates = async () => {
            try {
                const isZipCode = formLocation.zipCode! ? true : false
                handlerLoaders('loaderState', true)
                const data = await getStateByCountryServices(formLocation.zipCode! || formLocation.country!, isZipCode)
                setStates(parseToSelectOption(data, 'label', 'value'))
                handlerLoaders('loaderState', false)
            } catch (error) {
                setStates([])
            }{}
        }

        getStates()
        handlerForm('zipCode', null)
        handlerForm('cities', null)
        handlerForm('state', null)
        handlerForm('locality', null)
        handlerForm('cologne', null)
    }, [formLocation.country])

    // Consultamos los estados
    useEffect(() => {
        setCities([])
        setStates([])
        if (formLocation.zipCode) {
            const getStates = async () => {
                handlerLoaders('loaderState', true)
                const data = await getStateByCountryServices(formLocation.zipCode!, true)
                setStates(parseToSelectOption(data, 'label', 'value'))
                handlerLoaders('loaderState', false)
            }
            getStates()
        }
        handlerForm('cities', null)
        handlerForm('state', null)
    }, [formLocation.zipCode])

    // Consultamos los municipios
    useEffect(() => {
        setLocality([])
        setCologne([])
        if (formLocation.state) {
            const getCities = async () => {
                handlerLoaders('loaderCity', true)
                const data = await getCityByStateServices(formLocation.state!)
                setCities(parseToSelectOption(data, 'label', 'value'))
                handlerLoaders('loaderCity', false)
            }
            getCities()
        }
        handlerForm('cities', null)
        handlerForm('locality', null)
        handlerForm('cologne', null)
    }, [formLocation.state])

    //Consultamos las localidades
    useEffect(() => {
        setCologne([])
        if (formLocation.cities) {
            const getSatLocality = async () => {
                handlerLoaders('loaderLocality', true)
                const data = await getSatLocalityServices(formLocation.state!)
                setLocality(parseToSelectOption(data, 'label', 'value'))
                handlerLoaders('loaderLocality', false)
            }
            getSatLocality()
        }
        handlerForm('cologne', null)
    }, [formLocation.cities])

    //Consultamos las colonias
    useEffect(() => {
        if (formLocation.locality) {
            const getCologne = async () => {
                handlerLoaders('loaderCologne', true)
                const data = await getCologneServices(formLocation.zipCode!)
                setCologne(parseToSelectOption(data, 'label', 'value'))
                handlerLoaders('loaderCologne', false)
            }
            getCologne()
        }
    }, [formLocation.locality])

    return [countries, zipCode, states, cities, locality, cologne, formLocation, loaders, handlerForm, handlerReset]
}

export default useLocation
